import React from "react";
import { Field, Form, Formik } from "formik";
import styled from "styled-components";
import SearchBarFieldsFilter from "data-lake/preview/SearchBarFieldsFilter";
import {
  SearchBarContainer,
  SearchButtonAndQuery,
  SearchInputAndValidationContainer,
  SearchQueryRow,
  TimeRangeRow
} from "views/components/searchbar/SearchBarLayout";
import TimeRangeFilter from "views/components/searchbar/time-range-filter";
import SearchButton from "views/components/searchbar/SearchButton";
import { Button, ButtonGroup } from "components/bootstrap";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
export const WAHREHOUSE_PREVIEW_FORM_ID = "data-lake-preview-form";
const StreamsContainer = styled.div`
  display: flex;
  flex: 1;
`;
const SearchBar = ({
  disableSubmit = false,
  emptyFormValues,
  formRef = void 0,
  initialValues,
  onReset,
  onSubmit,
  rightColumn = void 0,
  searchJobIsRunning,
  validate = void 0,
  actions = void 0
}) => {
  const sendTelemetry = useSendTelemetry("search-bar");
  const { selectedDataLake } = useSelectedDataLake();
  const onSubmitButtonClick = (e) => {
    if (searchJobIsRunning) {
      if (
        // eslint-disable-next-line no-alert
        !window.confirm(
          "A preview search is already running. Starting a new search will cancel the ongoing job. Do you want to proceed?"
        )
      ) {
        sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].START_NEW_SEARCH_WHILE_LOADING, {
          app_pathname: "/data-storage/preview",
          app_action_value: "cancel-search",
          event_details: {
            data_lake_storage_type: selectedDataLake.storageType
          }
        });
        e.preventDefault();
      }
    }
  };
  const _onSubmit = (values, { resetForm }) => {
    resetForm({ values });
    return onSubmit(values);
  };
  return /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: _onSubmit, validate, innerRef: formRef }, ({ dirty, isSubmitting, isValid, isValidating, resetForm }) => {
    const disableSearchSubmit = disableSubmit || isSubmitting || isValidating || !isValid;
    const resetSearch = () => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].RESET_BUTTON_CLICKED, {
        app_pathname: "/data-storage/preview",
        app_action_value: "reset-button",
        event_details: {
          data_lake_storage_type: selectedDataLake.storageType
        }
      });
      resetForm({
        values: emptyFormValues
      });
      onReset();
    };
    return /* @__PURE__ */ React.createElement(Form, { id: WAHREHOUSE_PREVIEW_FORM_ID }, /* @__PURE__ */ React.createElement(SearchBarContainer, null, /* @__PURE__ */ React.createElement(TimeRangeRow, null, /* @__PURE__ */ React.createElement(Field, { name: "timerange" }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(
      TimeRangeFilter,
      {
        limitDuration: 0,
        onChange: (nextTimeRange) => onChange({
          target: { value: nextTimeRange, name }
        }),
        value,
        hasErrorOnMount: !!error,
        submitOnPresetChange: false
      }
    )), /* @__PURE__ */ React.createElement(StreamsContainer, null, rightColumn)), /* @__PURE__ */ React.createElement(SearchQueryRow, null, /* @__PURE__ */ React.createElement(SearchButtonAndQuery, null, /* @__PURE__ */ React.createElement(
      SearchButton,
      {
        disabled: disableSearchSubmit,
        dirty,
        displaySpinner: isSubmitting,
        onClick: onSubmitButtonClick
      }
    ), /* @__PURE__ */ React.createElement(SearchInputAndValidationContainer, null, /* @__PURE__ */ React.createElement(SearchBarFieldsFilter, null)), /* @__PURE__ */ React.createElement(ButtonGroup, null, actions, /* @__PURE__ */ React.createElement(Button, { onClick: resetSearch, title: "Clear filters and results" }, "Reset"))))));
  });
};
export default SearchBar;
